export default{
    url: "http://175.24.249.4/files/happy_binary_resource/official_website_pc/resource_static",
    api:'http://123.206.54.57:6005'
}